var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("Analysis")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                { attrs: { title: "Report Configuration", active: "" } },
                [
                  _c(
                    "span",
                    { staticClass: "col col-sm-4 text-left" },
                    [
                      !_vm.applying
                        ? _c(
                            "a",
                            {
                              staticClass: "clickable",
                              on: {
                                click: function($event) {
                                  _vm.apply()
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "poll", size: "1x" }
                              }),
                              _vm._v(" Apply\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.applying
                        ? _c("font-awesome-icon", {
                            attrs: { icon: "spinner", size: "lg", spin: "" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.surveyRuns.length === 1
                    ? _c(
                        "span",
                        { staticClass: "col col-sm-6 text-left" },
                        [
                          !_vm.downloading
                            ? _c(
                                "a",
                                {
                                  staticClass: "clickable",
                                  on: {
                                    click: function($event) {
                                      _vm.download(_vm.surveyRuns[0])
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "file-download", size: "1x" }
                                  }),
                                  _vm._v(" Download\n        ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.downloading
                            ? _c("font-awesome-icon", {
                                attrs: { icon: "spinner", size: "lg", spin: "" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("table", { staticClass: "table" }, [
                    _c(
                      "tbody",
                      [
                        !!_vm.dimensions
                          ? _c(
                              "draggable",
                              {
                                model: {
                                  value: _vm.dimensions,
                                  callback: function($$v) {
                                    _vm.dimensions = $$v
                                  },
                                  expression: "dimensions"
                                }
                              },
                              _vm._l(_vm.dimensions, function(item, index) {
                                return _c(
                                  "tr",
                                  { key: index, staticClass: "d-flex" },
                                  [
                                    _c(
                                      "th",
                                      {
                                        staticClass: "text-left col-2",
                                        attrs: { scope: "row" }
                                      },
                                      [
                                        _c("font-awesome-icon", {
                                          attrs: { icon: "sort", size: "1x" }
                                        }),
                                        _vm._v(_vm._s(item.dimensionName))
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-left col-10" },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "text-left align-left",
                                                attrs: { cols: "3" }
                                              },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.report,
                                                      expression: "item.report"
                                                    }
                                                  ],
                                                  attrs: { type: "checkbox" },
                                                  domProps: {
                                                    value: item.report,
                                                    checked: Array.isArray(
                                                      item.report
                                                    )
                                                      ? _vm._i(
                                                          item.report,
                                                          item.report
                                                        ) > -1
                                                      : item.report
                                                  },
                                                  on: {
                                                    change: function($event) {
                                                      var $$a = item.report,
                                                        $$el = $event.target,
                                                        $$c = $$el.checked
                                                          ? true
                                                          : false
                                                      if (Array.isArray($$a)) {
                                                        var $$v = item.report,
                                                          $$i = _vm._i($$a, $$v)
                                                        if ($$el.checked) {
                                                          $$i < 0 &&
                                                            _vm.$set(
                                                              item,
                                                              "report",
                                                              $$a.concat([$$v])
                                                            )
                                                        } else {
                                                          $$i > -1 &&
                                                            _vm.$set(
                                                              item,
                                                              "report",
                                                              $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                )
                                                            )
                                                        }
                                                      } else {
                                                        _vm.$set(
                                                          item,
                                                          "report",
                                                          $$c
                                                        )
                                                      }
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("small", [
                                                  _vm._v(
                                                    "Report on this category"
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.dimensionName !== "Year" &&
                                            item.dimensionName !== "Period"
                                              ? _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "text-right align-right",
                                                    attrs: { cols: "6" }
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            item.ignoreNotSpecified,
                                                          expression:
                                                            "item.ignoreNotSpecified"
                                                        }
                                                      ],
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      domProps: {
                                                        value:
                                                          item.ignoreNotSpecified,
                                                        checked: Array.isArray(
                                                          item.ignoreNotSpecified
                                                        )
                                                          ? _vm._i(
                                                              item.ignoreNotSpecified,
                                                              item.ignoreNotSpecified
                                                            ) > -1
                                                          : item.ignoreNotSpecified
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              item.ignoreNotSpecified,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v =
                                                                item.ignoreNotSpecified,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  item,
                                                                  "ignoreNotSpecified",
                                                                  $$a.concat([
                                                                    $$v
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  item,
                                                                  "ignoreNotSpecified",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              item,
                                                              "ignoreNotSpecified",
                                                              $$c
                                                            )
                                                          }
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("small", [
                                                      _vm._v(
                                                        "Ignore responses where this question was not answered."
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            item.dimensionName !== "Year" &&
                                            item.dimensionName !== "Period"
                                              ? _c(
                                                  "b-col",
                                                  {
                                                    staticClass:
                                                      "text-right align-right",
                                                    attrs: { cols: "3" }
                                                  },
                                                  [
                                                    _c("input", {
                                                      attrs: {
                                                        type: "checkbox"
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.checkUncheckDimensions(
                                                            index,
                                                            $event
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("small", [
                                                      _vm._v(
                                                        "Check/Uncheck All"
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        item.report
                                          ? _c(
                                              "draggable",
                                              {
                                                model: {
                                                  value: item.responseValues,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "responseValues",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.responseValues"
                                                }
                                              },
                                              _vm._l(
                                                item.responseValues,
                                                function(element, index1) {
                                                  return _c(
                                                    "li",
                                                    {
                                                      key: index1,
                                                      staticClass:
                                                        "list-group-item"
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: "sort",
                                                          size: "1x"
                                                        }
                                                      }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(element.text) +
                                                          " reported as "
                                                      ),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value: element.as,
                                                            expression:
                                                              "element.as"
                                                          }
                                                        ],
                                                        staticClass: "input-lg",
                                                        attrs: { type: "text" },
                                                        domProps: {
                                                          value: element.as
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              element,
                                                              "as",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      item.dimensionName !==
                                                        "Year" &&
                                                      item.dimensionName !==
                                                        "Period"
                                                        ? _c("span", [
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    _vm
                                                                      .dimensions[
                                                                      index
                                                                    ]
                                                                      .responseValues[
                                                                      index1
                                                                    ].ignore,
                                                                  expression:
                                                                    "dimensions[index].responseValues[index1].ignore"
                                                                }
                                                              ],
                                                              attrs: {
                                                                type: "checkbox"
                                                              },
                                                              domProps: {
                                                                checked: Array.isArray(
                                                                  _vm
                                                                    .dimensions[
                                                                    index
                                                                  ]
                                                                    .responseValues[
                                                                    index1
                                                                  ].ignore
                                                                )
                                                                  ? _vm._i(
                                                                      _vm
                                                                        .dimensions[
                                                                        index
                                                                      ]
                                                                        .responseValues[
                                                                        index1
                                                                      ].ignore,
                                                                      null
                                                                    ) > -1
                                                                  : _vm
                                                                      .dimensions[
                                                                      index
                                                                    ]
                                                                      .responseValues[
                                                                      index1
                                                                    ].ignore
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm
                                                                        .dimensions[
                                                                        index
                                                                      ]
                                                                        .responseValues[
                                                                        index1
                                                                      ].ignore,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c = $$el.checked
                                                                      ? true
                                                                      : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v = null,
                                                                      $$i = _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        _vm.$set(
                                                                          _vm
                                                                            .dimensions[
                                                                            index
                                                                          ]
                                                                            .responseValues[
                                                                            index1
                                                                          ],
                                                                          "ignore",
                                                                          $$a.concat(
                                                                            [
                                                                              $$v
                                                                            ]
                                                                          )
                                                                        )
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        _vm.$set(
                                                                          _vm
                                                                            .dimensions[
                                                                            index
                                                                          ]
                                                                            .responseValues[
                                                                            index1
                                                                          ],
                                                                          "ignore",
                                                                          $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            )
                                                                        )
                                                                    }
                                                                  } else {
                                                                    _vm.$set(
                                                                      _vm
                                                                        .dimensions[
                                                                        index
                                                                      ]
                                                                        .responseValues[
                                                                        index1
                                                                      ],
                                                                      "ignore",
                                                                      $$c
                                                                    )
                                                                  }
                                                                }
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("small", [
                                                              _vm._v(
                                                                "Ignore responses with this value"
                                                              )
                                                            ])
                                                          ])
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                }
                                              )
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                )
                              })
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.barChartData && !_vm.applying
                ? _c(
                    "b-tab",
                    { attrs: { title: "Group Data" } },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c("score-summary", {
                        attrs: { "chart-data": _vm.barChartData }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.barChartData && !_vm.applying
                ? _c(
                    "b-tab",
                    { attrs: { title: "Element Score Graphs" } },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "text-right align-right" },
                        [
                          _c("b-col", [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.skipBarTotals,
                                  expression: "skipBarTotals"
                                }
                              ],
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.skipBarTotals)
                                  ? _vm._i(_vm.skipBarTotals, null) > -1
                                  : _vm.skipBarTotals
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.skipBarTotals,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.skipBarTotals = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.skipBarTotals = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.skipBarTotals = $$c
                                  }
                                }
                              }
                            }),
                            _c("small", [_vm._v('Omit "Overall" bar')])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("score-bar-chart", {
                        attrs: {
                          "chart-data": _vm.barChartData,
                          width: 700,
                          height: _vm.positiveHeight,
                          type: "positive",
                          "programme-name": _vm.surveyRuns[0].programmeName,
                          "skip-totals": _vm.skipBarTotals
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("score-bar-chart", {
                        attrs: {
                          "chart-data": _vm.barChartData,
                          width: 700,
                          height: _vm.negativeHeight,
                          type: "negative",
                          "programme-name": _vm.surveyRuns[0].programmeName,
                          "skip-totals": _vm.skipBarTotals
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.barChartData && !_vm.applying
                ? _c(
                    "b-tab",
                    { attrs: { title: "Overall Score Graphs" } },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c("chevron-and-x", {
                        attrs: {
                          width: 350,
                          height: 400,
                          "chart-data": _vm.overallScore
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right align-right",
                              attrs: { cols: "8" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.skipBarOverall,
                                    expression: "skipBarOverall"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(_vm.skipBarOverall)
                                    ? _vm._i(_vm.skipBarOverall, null) > -1
                                    : _vm.skipBarOverall
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.skipBarOverall,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.skipBarOverall = $$a.concat([
                                            $$v
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.skipBarOverall = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.skipBarOverall = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-left align-left",
                              attrs: { cols: "4" }
                            },
                            [_c("small", [_vm._v('Omit "Overall" bar')])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "text-right align-right",
                              attrs: { cols: "8" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.yearsAndPeriodsAsBars,
                                    expression: "yearsAndPeriodsAsBars"
                                  }
                                ],
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.yearsAndPeriodsAsBars
                                  )
                                    ? _vm._i(_vm.yearsAndPeriodsAsBars, null) >
                                      -1
                                    : _vm.yearsAndPeriodsAsBars
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.yearsAndPeriodsAsBars,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.yearsAndPeriodsAsBars = $$a.concat(
                                            [$$v]
                                          ))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.yearsAndPeriodsAsBars = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.yearsAndPeriodsAsBars = $$c
                                    }
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "text-left align-left",
                              attrs: { cols: "4" }
                            },
                            [
                              _c("small", [
                                _vm._v("Display Period + Year as Bars")
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("gear-bar", {
                        attrs: {
                          width: 1000,
                          height: 600,
                          "chart-data": _vm.barChartData,
                          "overall-score": _vm.overallScore,
                          "skip-overall-bar": _vm.skipBarOverall,
                          "year-dimension": _vm.yearDimension,
                          "period-dimension": _vm.periodDimension,
                          "year-dimension-index": _vm.yearDimensionIndex,
                          "period-dimension-index": _vm.periodDimensionIndex,
                          "years-and-periods-as-bars":
                            _vm.yearsAndPeriodsAsBars,
                          "programme-name": _vm.surveyRuns[0].programmeName
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.industryAverages && !_vm.applying
                ? _c(
                    "b-tab",
                    { attrs: { title: "Industry Graphs" } },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c("gear-industry-bar", {
                        attrs: {
                          "chart-data": _vm.industryAverages,
                          "survey-runs": _vm.surveyRuns,
                          width: 800,
                          height: 350
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.industryAverages
                        ? _c("element-industry-line", {
                            attrs: {
                              "chart-data": _vm.barChartData,
                              "industry-data": _vm.industryAverages,
                              type: "positive",
                              width: 1000,
                              height: 600
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.industryAverages
                        ? _c("element-industry-line", {
                            attrs: {
                              "chart-data": _vm.barChartData,
                              "industry-data": _vm.industryAverages,
                              type: "negative",
                              width: 600,
                              height: 600
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.barChartData && !_vm.applying
                ? _c(
                    "b-tab",
                    { attrs: { title: "Comments" } },
                    [
                      _c("comments-list", {
                        attrs: {
                          "survey-runs": _vm.surveyRuns,
                          dimensions: _vm.dimensionsForComments,
                          "show-type-selection": ""
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticStyle: { height: "100px" } })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-237490f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-237490f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SurveyAnalysis.vue
// module id = null
// module chunks = 